import React, { useEffect, useState } from "react";
import Layout from '../layout'
import "./forget.css";
// import logo from "../../assets/images/header/logo.png";
import { Form, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { validateData } from "../../function/function";
import { NotificationManager } from "react-notifications";
import { userInstance } from "../../axios/axiosconfig";
import { useTranslation } from "react-i18next";
import {cmsInstance} from '../../axios/axiosconfig';
const INITIAL_STATE = {
    email: ''
}

const Forgetpass = () => {
    const { t, i18n } = useTranslation();
    const [values, setValues] = useState(INITIAL_STATE);
    const [content, setContent] = useState({});

    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
        
    }
    useEffect(() => {
      
        getContent();
    }, [])
    const getContent = async () => {
        try {
          // const page = window.location.pathname.replace('/cms/', '');
          const page = '/forgetpassword';
           let language = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : localStorage.getItem('i18nextLng');
          const { data: { content, msg }, status } = await cmsInstance.get(`/content${page}/${language}`);
          if (status == 200) {
            setContent(content);
            
          } else {
            NotificationManager.error(msg, "Message", 10000);
          }
        } catch (error) {
          console.log('Error', error.message);
        }
      }
    const handleSubmit = async (event) => {
        event.preventDefault();

        const isValid = validateData([
            values.email
        ]);
        if (isValid) {
            const response = await userInstance.post("/resetpassword", values);
            const statusCode = response.data.code;
            const msg = response.data.msg;
            if (statusCode == 200) {
                setValues(INITIAL_STATE);
                NotificationManager.success(content.notification2, "Message", 4000);
            } else {
                NotificationManager.error(content.notification3, "Message", 4000);
            }
        } else {
            NotificationManager.error(content.notification1, "Message", 4000);
        }
    }

    return (
        <div className="forget">
            <div className="forget-section">
                <div className="container">
                    <div classNmae="row">
                        <div className="col-md-12">
                            <div className="forget-form">
                                <h1>{content.heading1} <span>{content.heading2}</span></h1>
                                <div className="forget-box">
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group>
                                            <Form.Label>{content.para1}</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder={content.para3}
                                                name="email"
                                                onChange={handleChange}
                                                value={values.email}
                                            />
                                        </Form.Group>
                                        <div className="forget-button">
                                            <Button type="submit" className="red-btn" >
                                            {content.para2}
                                        </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Forgetpass;